/* tslint:disable:max-line-length */
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { MODALS_TYPE } from '@mm/state/modules/modalsState/types';
import { useEffect, useState } from 'react';
import validator from 'validator';
import { useGetWebsiteTraffic } from '../hooks/use-get-website-traffic';
import { extractDomainName } from './constants';

export const useWebsiteReportModals = () => {
  const [activeStep, setActiveStep] = useState(2);
  const [showPaidTrafficROI, setShowPaidTrafficROI] = useState(false);

  const websiteURL =
    window.location.pathname === '/report'
      ? ''
      : extractDomainName(window.location.pathname) || '';

  const {
    openEditWebsiteURLModal,
    openSignupXRayModal,
    openAnalyzeWebsiteTrafficModal,
    openPromoteInstachampModal,
    openClarifyWebsiteTrafficModal,
    closeModal,
  } = useModalActions();

  const openTrafficAbsentModal = () => {
    openClarifyWebsiteTrafficModal({
      website: websiteURL,
      totalTraffic,
      setTotalTraffic,
    });
  };

  const openAnalyzeWebsiteTraffic = () => {
    openAnalyzeWebsiteTrafficModal({ website: websiteURL });
  };

  const openInstachampModal = () => {
    openPromoteInstachampModal();
  };

  const openSignupModal = () => {
    setActiveStep(3);
    openSignupXRayModal({
      onClose: () => {
        setActiveStep(2);
        closeModal(MODALS_TYPE.SIGN_UP_X_RAY_MODAL);
      },
      website: websiteURL,
    });
  };

  const openEditUrlModal = () => {
    setActiveStep(1);
    openEditWebsiteURLModal({
      onClose: () => {
        setActiveStep(2);
        closeModal(MODALS_TYPE.EDIT_WEBSITE_URL);
      },
      hideClose: !websiteURL,
    });
  };

  const {
    retrieveStats,
    totalTrafficRef,
    monthlyTrafficRef,
    busy,
    totalTraffic,
    setTotalTraffic,
  } = useGetWebsiteTraffic({
    onTrafficAbsent: openTrafficAbsentModal,
    onNonUSTraffic: openInstachampModal,
    setShowPaidTrafficROI,
  });

  useEffect(() => {
    (async () => {
      if (websiteURL && validator.isURL(websiteURL)) {
        openAnalyzeWebsiteTraffic();
        setActiveStep(2);
        await retrieveStats(websiteURL);

        closeModal(MODALS_TYPE.ANALYZE_WEBSITE_TRAFFIC_MODAL);
      } else {
        openEditUrlModal();
      }
    })();
  }, []);

  return {
    openTrafficAbsentModal,
    openInstachampModal,
    openSignupModal,
    openEditUrlModal,
    openAnalyzeWebsiteTraffic,
    websiteURL,
    totalTrafficRef,
    monthlyTrafficRef,
    busy,
    activeStep,
    totalTraffic,
    setTotalTraffic,
    showPaidTrafficROI,
  };
};
